export default __webpack_public_path__ + "static/media/Daniel_Santamaria.310ddeb4.png";